import React, {Fragment } from 'react';
import {
    Link
  }from 'react-router-dom';

import logo from './oil_pain.png';
import { auth } from './firebase';


function Navbar(logged)
 {
   let Component;
   if(logged)
   Component = <div className="nav-link" onClick={auth.logout}> logout </div>;
   else
   Component = <Fragment>
   <Link to="/login"><div className="nav-link"> login </div></Link>
   <Link to="/singup"><div className="nav-link"> sing up </div></Link>
   </Fragment>
    return (
      
        <div className="Navbar">
            <nav className="navbar navbar-expand-sm navbar-light bg-light">
            <Link to="/"><img className="img-fluid d-inline-block align-top" src={logo} width="30" height="30" alt=""></img>Creator CV</Link>
              <ul className="navbar-nav ml-auto">
              {Component}
              </ul>
            </nav>
        </div>
    );
}

export default Navbar;

